import templateStr from 'text!./pa-edit-driver.html';
import LocalDateUtil from 'gw-portals-util-js/LocalDateUtil';

export default ['AgeAllowedToDrive', 'pa.qnb.editableDriverDOB', function (AgeAllowedToDrive, editableDriverDOB) {
    return {
        restrict: 'A',
        scope: {
            driver: '='
        },
        template: templateStr,
        controller: ['$scope', function ($scope) {
            var deregisterDriverWatch = void 0;
            var deregisterDobWatch = void 0;

            function resetForm() {
                var startingYear = new Date();

                $scope.editableDriverDOB = editableDriverDOB;
                $scope.maxDateOfBirth = {
                    year: startingYear.getFullYear() - AgeAllowedToDrive,
                    month: startingYear.getMonth(),
                    day: startingYear.getDate()
                };

                $scope.years = [];
                var currentYear = new Date().getUTCFullYear();

                $scope.setYears = function (earliestYear) {
                    $scope.years.length = 0;
                    for (var i = currentYear - earliestYear; i <= currentYear; i++) {
                        $scope.years.unshift(i);
                        if (i === currentYear) {
                            // last iteration of loop, if user has changed their dob to be after year first licensed
                            // make sure that the yearLicensed previously chosen is still valid.
                            if ($scope.driver.value && $scope.driver.yearLicensed.value && $scope.years.indexOf($scope.driver.yearLicensed.value) === -1) {
                                $scope.driver.yearLicensed.value = undefined;
                            }
                        }
                    }
                };

                if ($scope.driver.value && $scope.driver.dateOfBirth.value) {
                    var dobDate = $scope.driver.dateOfBirth.value;
                    $scope.setYears(currentYear - (dobDate.year + AgeAllowedToDrive));
                } else {
                    $scope.setYears(AgeAllowedToDrive);
                }

                deregisterDobWatch = $scope.$watch('driver.dateOfBirth.value', function (dob) {
                    if (angular.isDefined(dob)) {
                        $scope.setYears(currentYear - (dob.year + AgeAllowedToDrive));
                    }
                }, true);

                deregisterDriverWatch = $scope.$watch('driver.value', function () {
                    if (angular.isDefined($scope.driver.value)) {
                        $scope.fixedDateOfBirth = LocalDateUtil.toMidnightDate($scope.driver.dateOfBirth.value);
                        $scope.driver.accidents.value = $scope.driver.accidents.value || $scope.driver.accidents.aspects.availableValues[0];
                        $scope.driver.violations.value = $scope.driver.violations.value || $scope.driver.violations.aspects.availableValues[0];
                    }
                });
            }

            resetForm();
            $scope.$on('update-form', function () {
                deregisterDriverWatch();
                deregisterDobWatch();
                resetForm();
            });
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/pa/directives/pa-edit-driver/PAEditDriver.js
// module id = 2174
// module chunks = 0